import EditTable from './editTable.vue';

export default EditTable;
